import React from 'react';
import { motion } from 'framer-motion';
import { HeartCrack, BrainCog, BatteryLow } from 'lucide-react';
export function CostOfWaitingSection() {
  const costs = [{
    icon: <HeartCrack size={36} strokeWidth={1.5} data-id="element-114" />,
    title: 'Desgaste Emocional',
    desc: 'Vivir en una montaña rusa de nostalgia, ansiedad y esperanza falsa que te impide disfrutar tu presente.',
    color: 'from-urgency/10 to-soft/20',
    iconBg: 'bg-urgency/15 text-urgency'
  }, {
    icon: <BrainCog size={36} strokeWidth={1.5} data-id="element-115" />,
    title: 'Agotamiento Mental',
    desc: 'Tu mente consume toda su energía analizando el pasado, dejándote sin claridad para tomar decisiones hoy.',
    color: 'from-accent/10 to-soft/20',
    iconBg: 'bg-accent/15 text-accent'
  }, {
    icon: <BatteryLow size={36} strokeWidth={1.5} data-id="element-116" />,
    title: 'Pérdida de Identidad',
    desc: 'Sientes que una parte de ti se quedó pausada en esa historia, perdiendo el foco en tus propios proyectos y vida.',
    color: 'from-primary/10 to-soft/20',
    iconBg: 'bg-primary/15 text-primary'
  }];
  return <section className="py-20 md:py-24 px-4 bg-cream" data-id="element-117">
      <div className="max-w-5xl mx-auto" data-id="element-118">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-14" data-id="element-119">
          <h2 className="font-serif font-bold text-3xl md:text-5xl text-primary mb-4 leading-tight" data-id="element-120">
            El costo invisible de seguir esperando
          </h2>
          <p className="font-sans text-ink/70 max-w-xl mx-auto" data-id="element-121">
            Cada día que pasa sin cerrar este ciclo tiene un precio que pagas en
            silencio.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-122">
          {costs.map((cost, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`bg-gradient-to-br ${cost.color} bg-white p-8 rounded-2xl shadow-lg border border-soft/30 flex flex-col items-center text-center hover:-translate-y-1 transition-transform`} data-id="element-123">
              <div className={`${cost.iconBg} mb-5 p-5 rounded-2xl shadow-sm`} data-id="element-124">
                {cost.icon}
              </div>
              <h3 className="font-serif font-bold text-xl text-primary mb-3" data-id="element-125">
                {cost.title}
              </h3>
              <p className="text-ink/75 text-sm leading-relaxed font-sans" data-id="element-126">
                {cost.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center max-w-3xl mx-auto bg-primary/5 border-l-4 border-accent rounded-r-2xl p-8" data-id="element-127">
          <p className="font-serif italic text-xl md:text-3xl text-primary leading-relaxed" data-id="element-128">
            "¿Cuánto te está costando seguir entregándole espacio interno a
            alguien que <span className="not-italic font-bold" data-id="element-129">ya no está</span>{' '}
            en tu vida?"
          </p>
        </motion.div>
      </div>
    </section>;
}